import type { SVGProps } from "react";

export const NavigaTUMLogo = (props: SVGProps<SVGSVGElement>) => (
	<svg
		aria-labelledby="navigatum-logo"
		viewBox="0 0 53.137 8.497"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<title id="navigatum-logo">
			Logo of NavigaTUM showing a map pin next to the text NavigaTUM
		</title>
		<g strokeWidth={1.306}>
			<path
				aria-label="NavigaTUM Logo"
				d="M12.275 6.6h-.858L8.159 1.607v4.995h-.858V.119h.858l3.267 5.017V.12h.849zm4.355 0q-.07-.142-.115-.507-.574.597-1.37.597-.71 0-1.168-.4-.453-.406-.453-1.025 0-.752.569-1.166.573-.418 1.608-.418h.8v-.379q0-.432-.257-.685-.258-.258-.76-.258-.44 0-.738.222-.298.223-.298.539h-.827q0-.36.254-.695.258-.338.693-.534.44-.196.965-.196.83 0 1.302.419.47.414.489 1.144v2.217q0 .663.169 1.055v.07zm-1.364-.627q.387 0 .733-.2.347-.2.502-.521v-.988h-.644q-1.511 0-1.511.886 0 .387.258.605.257.218.662.218zm4.871-.49 1.191-3.699h.84l-1.724 4.817h-.627l-1.742-4.817h.84zM23.853 6.6h-.823V1.785h.823zm-.89-6.093q0-.2.12-.339.125-.138.365-.138t.365.138q.124.138.124.339 0 .2-.124.334-.125.133-.365.133t-.364-.133q-.12-.134-.12-.334zm2.005 3.646q0-1.127.52-1.79.52-.668 1.378-.668.88 0 1.373.624l.04-.535h.751v4.701q0 .935-.555 1.473-.551.54-1.485.54-.52 0-1.017-.223-.498-.223-.76-.61l.426-.494q.53.654 1.294.654.6 0 .933-.338.338-.339.338-.953V6.12q-.494.57-1.347.57-.844 0-1.369-.681-.52-.681-.52-1.856zm.827.093q0 .815.333 1.282.333.463.933.463.778 0 1.143-.708V3.084q-.378-.69-1.134-.69-.6 0-.937.468-.338.467-.338 1.384zm7.44 2.354q-.071-.142-.116-.507-.573.597-1.369.597-.71 0-1.169-.4-.453-.406-.453-1.025 0-.752.569-1.166.573-.418 1.609-.418h.8v-.379q0-.432-.258-.685-.258-.258-.76-.258-.44 0-.738.222-.297.223-.297.539h-.827q0-.36.253-.695.258-.338.694-.534.44-.196.964-.196.831 0 1.302.419.471.414.49 1.144v2.217q0 .663.168 1.055v.07zm-1.365-.627q.387 0 .734-.2.346-.2.502-.521v-.988h-.645q-1.51 0-1.51.886 0 .387.257.605.258.218.662.218zm7.956-5.15h-2.08V6.6h-.85V.823h-2.075V.119h5.005zM45.35.12v4.406q-.004.917-.578 1.5-.568.584-1.546.655l-.227.009q-1.062 0-1.693-.574-.631-.575-.64-1.58V.118h.844v4.39q0 .703.387 1.095.387.387 1.102.387.725 0 1.107-.387.386-.388.386-1.09V.118zm2.45 0 2.115 5.288L52.03.119h1.107v6.482h-.853V4.077l.08-2.724L50.239 6.6h-.653l-2.12-5.235.084 2.71V6.6h-.853V.119z"
				fill="#0065bd"
				fontFamily="Roboto"
				fontSize={64.946}
				fontWeight={400}
				letterSpacing={0}
				strokeWidth={1.886}
				style={{
					lineHeight: 1.25,
				}}
				wordSpacing={0}
			/>
			<g transform="matrix(.76483 0 0 .76603 78.289 -128.686)">
				<path
					d="M-99.252 175.947c-1.118-1.84-1.398-1.857-2.285-3.464-.886-1.606.035-3.942 2.285-4.003 2.25.06 3.17 2.397 2.284 4.003-.887 1.607-1.167 1.625-2.284 3.464z"
					fill="none"
					stroke="#0065bd"
					strokeWidth={0.98}
				/>
				<circle cx={-99.259} cy={171.104} fill="#0064c6" r={0.741} />
			</g>
		</g>
	</svg>
);
